import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function validationCountsReducer(state = initialstate.validations, action) {
	let documentId;
	switch (action.type) {
		case types.UNLOAD_VALIDATION_COUNTS: {
			documentId = action.documentId;

			return {
				...state,
				[documentId]: undefined
			};
		}
		case types.GET_VALIDATIONCOUNTS: {
			let result = {};
			let documentIds = action.documentIds;
			let embeddedDocumentIds = action.embeddedDocumentIds;

			if (embeddedDocumentIds) {
				for (let id of embeddedDocumentIds) {
					let validations = action?.response?.filter((v) => v.documentId === id);
					result[id] = validations;
				}
			} else {
				for (let id of documentIds) {
					let validations = action?.response?.filter((v) => v.documentId === id);

					// Always update validations
					result[id] = validations;
				}
			}

			return {
				...state,
				...result
			};
		}
		case types.REFRESH_VALIDATION_COUNTS:
			return null;
		default:
			return state;
	}
}

export function validationDetailsReducer(state = initialstate.validationdetails, action) {
	switch (action.type) {
		case types.UNLOAD_VALIDATION_DETAILS:
			return {};
		case types.GET_VALIDATIONDETAILS:
			return action.response || state;
		default:
			return state;
	}
}

export function withoutApprovalvalidationCountsReducer(state = initialstate.withoutapprovalvalidations, action) {
	switch (action.type) {
		case types.GET_WITHOUT_APPROVAL_VALIDATION_COUNTS: {
			let result = {};
			let documentIds = action.documentIds;

			for (let id of documentIds) {
				let validations = action.response.filter((v) => v.documentId === id);

				// Always update validations
				result[id] = validations;
			}

			return {
				...state,
				...result
			};
		}
		default:
			return state;
	}
}
